/* eslint-disable @typescript-eslint/no-unused-vars */
import { useAuthContext } from '@context/auth/useAuthContext';
import { useNavigate } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import { useTranslation } from 'react-i18next';

import { isDataExportNotificationType } from '../../consts/supportedNotificationTypes';
import useMarkNotifications from '../../hooks/useMarkNotifications';
import useOptimisticUpdates from '../../hooks/useOptimisticUpdates';
import { WidgetNotificationCardSelectorByType } from '../../NotificationSelectorByType';
import { DiscriminatedNotificationType } from '../../types/notifications';

// const isVisitMetadata = (
//   metadata: NotificationActionVisitMetadata | NotificationActionCarergiverShiftMetadata
// ): metadata is NotificationActionVisitMetadata => {
//   return 'visitId' in metadata;
// };

interface WidgetNotificationsListProps {
  userId: number;
  notifications: DiscriminatedNotificationType[];
  areNotificationsFetching: boolean;
  areNotificationsLoading: boolean;
  closeNotificationsPanel: () => void;
}
// interface NotificationsActionPayload {
//   notificationId: number;
//   visitId: number;
//   caregiverId: number;
//   metaData: NotificationActionVisitMetadata;
// }

const WidgetNotificationsList = ({
  userId,
  closeNotificationsPanel,
  notifications,
  areNotificationsFetching,
  areNotificationsLoading,
}: WidgetNotificationsListProps) => {
  const { t } = useTranslation();
  const { user } = useAuthContext();
  // const [clickedActionId, setClickedActionId] = useState<number | null>(null);
  const { markSingleNotificationAsRead } = useMarkNotifications();

  const { optimisticMarkOneAsReadForWidgetNotifications, optimisticMarkOneAsReadForFullNotificationPage } =
    useOptimisticUpdates({
      userId: user.userId,
    });

  const navigate = useNavigate();

  // const { acceptVisitRequestMutation, isAcceptVisitRequestPending } = useAcceptVisitRequest(user.userId);
  // const { rejectVisitRequestMutation, isRejectVisitRequestPending } = useRejectVisitRequest(user.userId);

  // TODO - ENABLE back on their specific components when the caregiver will login to the dashboard
  // const onAcceptVisitRequest = async ({
  //   notificationId,
  //   visitId,
  //   caregiverId,
  //   metaData,
  // }: NotificationsActionPayload) => {
  //   setClickedActionId(notificationId);

  //   await acceptVisitRequestMutation.mutateAsync({
  //     payload: {
  //       notificationId,
  //       visitId,
  //       caregiverId,
  //       metaData: metaData,
  //     },
  //   });

  //   setClickedActionId(null);
  // };

  // const onRejectVisitRequest = async ({
  //   notificationId,
  //   visitId,
  //   caregiverId,
  //   metaData,
  // }: NotificationsActionPayload) => {
  //   setClickedActionId(notificationId);

  //   await rejectVisitRequestMutation.mutateAsync({
  //     notificationId,
  //     visitId,
  //     caregiverId,
  //     metaData: metaData,
  //   });

  //   setClickedActionId(null);
  // };

  const onNotificationWidgetCardClick = (notificationId: number, notificationType?: string) => {
    // For export notifications, don't open modal - they handle their own download logic
    if (isDataExportNotificationType(notificationType)) {
      markSingleNotificationAsRead({ userId, notificationId });
      optimisticMarkOneAsReadForWidgetNotifications(notificationId);
      optimisticMarkOneAsReadForFullNotificationPage(notificationId);
      return;
    }
    navigate(`/dashboard/notifications/list?id=${notificationId}`);
    closeNotificationsPanel();
  };

  return (
    <div
      className={`flex flex-1 items-center justify-center text-sm text-slate-500 ${(areNotificationsLoading || areNotificationsFetching) && 'opacity-50 pointer-events-none'}`}
    >
      <SimpleBar forceVisible="y" autoHide className="w-full h-[480px]">
        {/* Skeleton when Fetching */}
        {areNotificationsFetching && areNotificationsLoading && (
          <li className="flex h-40 items-center justify-center text-lg text-slate-500 select-none">
            {t('notifications-widget-loading')}
            {/* Will add the skeletons here */}
          </li>
        )}

        {/* outcome When notifications are not present */}
        {notifications.length === 0 && (
          <li className="flex h-40 items-center justify-center text-lg text-slate-500 select-none">
            {t('notifications-widget-empty')}
          </li>
        )}

        <ul
          className={`divide-y divide-slate-100 ${(areNotificationsLoading || areNotificationsFetching) && 'opacity-100 pointer-events-none'}`}
        >
          {notifications?.map((item, index) => {
            // const areCaregiverActionsEnabled = user.isCaregiver && item.actionValue === null;
            // const metadata = item?.metadata?.[0];
            // const isVisit = metadata && isVisitMetadata(metadata);

            return (
              <WidgetNotificationCardSelectorByType
                key={item.notificationId}
                notification={item}
                onClick={() => {
                  onNotificationWidgetCardClick(item.notificationId, item.type);
                }}
              />
            );
          })}
        </ul>
      </SimpleBar>
    </div>
  );
};

export default WidgetNotificationsList;
